// Filters
export const DATE_RANGE_ACTION_DATE = 'DATE_RANGE_ACTION_DATE';
export const SHIP_DATE = 'SHIP_DATE';
export const GROUP_ITEM_DEMAND_BY = 'GROUP_ITEM_DEMAND_BY';
export const GROUP_PRODUCTS = 'GROUP_PRODUCTS';
export const INVENTORY_WAREHOUSE = 'INVENTORY_WAREHOUSE';
export const ORDERED_DURING = 'ORDERED_DURING';
export const SAVED_ORDER_FILTER = 'SAVED_ORDER_FILTER';
export const ORDER_STATUS = 'ORDER_STATUS';
export const PRODUCT_IMAGES = 'PRODUCT_IMAGES';
export const LABEL_PROVIDER = 'LABEL_PROVIDER';
export const PURCHASED_DURING = 'PURCHASED_DURING';
export const SERVICE = 'SERVICE';
export const SHIPPED_DURING = 'SHIPPED_DURING';
export const SHIPPING_ACCOUNT = 'SHIPPING_ACCOUNT';
export const SHIPPING_DATE = 'SHIPPING_DATE';
export const SHIP_FROM_LOCATION = 'SHIP_FROM_LOCATION';
export const SHOW_PRODUCTS = 'SHOW_PRODUCTS';
export const SHOW_PRODUCTS_ALIASES = 'SHOW_PRODUCTS_ALIASES';
export const SORT_ITEM_DEMAND_BY = 'SORT_ITEM_DEMAND_BY';
export const SPECIFIC_SKU = 'SPECIFIC_SKU-SKU';
export const STORE = 'STORE';
export const USER = 'USER';
export const SHOW_PRODUCT_SALES_BY = 'SHOW_PRODUCT_SALES_BY';
export const SHIPMENT_COUNT_BY_USER_GROUP_BY = 'SHIPMENT_COUNT_BY_USER_GROUP_BY';
export const GROUP_BY_PARENT_SKU = 'GROUP_BY_PARENT_SKU';
export const SHOW_PRODUCT_ALIASES_BY = 'SHOW_PRODUCT_ALIASES_BY';
export const SHOW_SHIPPED_ITEMS_BY = 'SHOW_SHIPPED_ITEMS_BY';
export const SHOW_ACCOUNT_BALANCE_BY = 'SHOW_ACCOUNT_BALANCE_BY';
export const HOTKEY_TYPE = 'HOTKEY_TYPE';
export const SHOW_BARCODE_SCAN_ACTION_BY = 'SHOW_BARCODE_SCAN_ACTION_BY';
export const SHOW_BARCODE_SCAN_ACTION_HOTKEYS = 'SHOW_BARCODE_SCAN_ACTION_HOTKEYS';
export const BARCODE_SCAN_ACTION_TYPE_GENERAL = 'BARCODE_SCAN_ACTION_TYPE_GENERAL';
export const BARCODE_SCAN_ACTION_TYPE_SHIPPING_PRESETS = 'BARCODE_SCAN_ACTION_TYPE_SHIPPING_PRESETS';
export const BARCODE_SCAN_ACTION_TYPE_SHIPPING_ORDERS = 'BARCODE_SCAN_ACTION_TYPE_SHIPPING_ORDERS';
export const BARCODE_SCAN_ACTION_TYPE_PRINTING_DOCUMENTS = 'BARCODE_SCAN_ACTION_TYPE_PRINTING_DOCUMENTS';
export const BARCODE_SCAN_ACTION_TYPE_NAVIGATION = 'BARCODE_SCAN_ACTION_TYPE_NAVIGATION';
export const LOT = 'LOT';
export const INVOICE_ID = 'INVOICE_ID';

export const HOTKEY_KEY_TYPE_BASIC = 'Basic';
export const HOTKEY_KEY_TYPE_ADVANCED = 'Advanced';
export const HOTKEY_KEY_TYPE_COMBINED = 'Combined';

// Types
export const CHECKBOX = 'checkbox';
export const DATE_PICKER = 'date-picker';
export const DATE_RANGE = 'data-range';
export const BILLING_DATE_RANGE = 'billing-date-range';
export const DROP_DOWN = 'dropdown';
export const TEXTBOX = 'textbox';
